import React, { useState, useEffect } from 'react';
import './editMyBump.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

// FUNCTIONS
import { reprocessTranscript } from '../reprocessTranscript';

const ProgressBarMyBump = ({
  videoId,
  user,
  videoTitle,
  videoQuality,
  videoDuration,
  isTranscriptReady,
  isProcessedbyAI,
  isYouTubePosted
}) => {
  const [transcriptError, setTranscriptError] = useState(false);
  // File size and thumbnail, which Reprocess sends back so the right-sized pipeline runs
  const [fileInfo, setFileInfo] = useState({ sizeMb: 0, thumbnail: null });

  useEffect(() => {
    if (!user?.uid) return undefined;
    const videoDocRef = doc(db, 'users', user.uid, 'bumpContent', `bump-${videoId}`);
    return onSnapshot(videoDocRef, docSnapshot => {
      if (!docSnapshot.exists()) return;
      const videoData = docSnapshot.data();
      setTranscriptError(!!videoData.is_transcript_error);
      setFileInfo({ sizeMb: videoData.video_blob_size_mb || 0, thumbnail: videoData.video_thumbnail || null });
    }, () => {});
  }, [user, videoId]);

  const handleReprocess = async () => {
    // Optimistically clear the error; the backend sets it again if processing fails
    setTranscriptError(false);
    const videoDocRef = doc(db, 'users', user.uid, 'bumpContent', `bump-${videoId}`);
    try {
      await updateDoc(videoDocRef, { is_transcript_error: false });
      await reprocessTranscript({
        user,
        generatedVideoId: videoId,
        videoTitle,
        videoQuality,
        videoDuration,
        videoSizeMb: fileInfo.sizeMb,
        videoThumbnail: fileInfo.thumbnail,
      });
    } catch (err) {
      // The job never started: show Reprocess again. A timeout means it's still running on the server.
      if (err?.code !== 'functions/deadline-exceeded') {
        setTranscriptError(true);
        updateDoc(videoDocRef, { is_transcript_error: true }).catch(() => {});
      }
    }
  };

  // Each step: label, circle state (done / active / idle) and how far its connector is filled
  const steps = [
    { label: 'Uploaded', state: 'done', line: isTranscriptReady || isProcessedbyAI ? 'full' : 'half' },
    { label: 'Bump AI Watching', state: isTranscriptReady ? 'done' : 'active', line: isProcessedbyAI ? 'full' : isTranscriptReady ? 'half' : '', error: transcriptError },
    { label: 'AI Description', state: isProcessedbyAI ? 'done' : isTranscriptReady ? 'active' : 'idle', line: isYouTubePosted ? 'full' : isProcessedbyAI ? 'half' : '' },
    { label: 'Visibility', state: isYouTubePosted ? 'done' : 'idle' },
  ];

  return (
    <div className="valueBump-progress-bar">
      {steps.map((step, i) => (
        <div key={step.label} className={`valueBump-progress-step is-${step.state}`}>
          <div className="valueBump-progress-label">{step.label}</div>
          <div className="valueBump-progress-circle-wrapper">
            {step.error ? (
              <button className="transcript-reprocess-button" onClick={handleReprocess}>
                Reprocess
              </button>
            ) : (
              <div className={`valueBump-progress-circle is-${step.state}`}>
                {step.state === 'done' && <FontAwesomeIcon icon={faCheck} />}
              </div>
            )}
            {i < steps.length - 1 && (
              <div className="valueBump-progress-line">
                <div className={`valueBump-progress-line-fill ${step.line ? `is-${step.line}` : ''}`} />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgressBarMyBump;
